import { Box, OutlinedInput, Stack } from '@mui/material';
import React, { useState } from 'react'
import Theme from '../../../../../constants/Theme';

function RazonSocial({formik}) {
  const [razonSocialHelperText, setRazonSocialHelperText] = useState(
    "Ingresa tu razón social"
  );
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={3}
      style={{ marginBottom: 10 }}
    >
      <Box style={{ flex: "1 1 35%" }}>
        <OutlinedInput
          placeholder="Razón Social"
          onFocus={() => setRazonSocialHelperText("Debe coincidir con tu constancia de situación fiscal")}
          onChange={(e) => {
            const razonSocial = e.target.value.toUpperCase();
            formik.setFieldValue("razonSocial", razonSocial, true);
          }}
          value={formik.values.razonSocial}
          error={formik.errors.razonSocial && formik.touched.razonSocial}
          type="text"
          style={{ width: "100%" }}
          autoComplete="new-password"
        />
        <p
          style={
            formik.errors.razonSocial && formik.touched.razonSocial
              ? { color: Theme.COLORS.ERROR }
              : razonSocialHelperText !== "Ingresa tu razón social" ?  { fontWeight: 'bold' } : {}
          }
          className="helperText"
        >
          {formik.errors.razonSocial && formik.touched.razonSocial
            ? formik.errors.razonSocial
            : razonSocialHelperText}
        </p>
      </Box>
    </Stack>
  );
}

export default RazonSocial